import { DEFAULT_APPEARANCE } from '@/theme/engine.mjs';
import { variantSummary } from "./variant-quantities.mjs";
import { isCheckingReceipt } from './checking-receipt';
import { buildCheckingEscpos } from './checking-escpos';
const rp = (n) => "Rp" + Math.round(Number(n || 0)).toLocaleString("id-ID");

export function buildEscpos(tx, s, cashier) {
  if (s.paper === 'custom') throw new Error('Ukuran Custom hanya untuk Komputer / Browser. Pilih 58 atau 80 mm untuk Bluetooth.');
  if (isCheckingReceipt(tx)) return buildCheckingEscpos(tx, s, cashier);
  const width = String(s.paper) === "58" ? 32 : 48;
  const line = (l, r) => {
    l = String(l); r = String(r);
    const space = Math.max(1, width - l.length - r.length);
    return l + " ".repeat(space) + r + "\n";
  };
  const center = (t) => {
    t = String(t);
    return t.length >= width ? t + "\n" : " ".repeat(Math.floor((width - t.length) / 2)) + t + "\n";
  };
  const dateStr = new Date(tx.created_at).toLocaleString("id-ID");
  let out = tx.is_reprint ? center('(REPRINT)') : '';
  out += center(s.store_name || DEFAULT_APPEARANCE.branding.name);
  if (s.address) out += center(s.address);
  if (s.phone) out += center("Telp " + s.phone);
  out += "-".repeat(width) + "\n";
  out += "No: " + tx.invoice_no + "\n";
  out += dateStr + "\n";
  out += "Kasir: " + (cashier || "") + "\n";
  out += "-".repeat(width) + "\n";
  tx.items.forEach((it) => {
    out += it.name + "\n";
    if (variantSummary(it)) out += variantSummary(it, " / ") + "\n";
    out += line(`${it.qty} x ${rp(it.price)}`, rp(it.qty * it.price));
    if (it.discount > 0) out += line("  Diskon item", "-" + rp(it.discount));
    if (it.note) out += "  * " + it.note + "\n";
  });
  out += "-".repeat(width) + "\n";
  out += line("Total Item", String(tx.items.reduce((s, it) => s + it.qty, 0)));
  out += line("Subtotal", rp(tx.subtotal));
  if (tx.discount > 0) out += line("Diskon", "-" + rp(tx.discount));
  for (const debt of tx.previous_debts || []) out += "Piutang sebelumnya (" + debt.invoice_no.slice(-4) + ")\n" + line("", rp(debt.amount));
  out += line("TOTAL", rp(tx.total + (tx.settlement_total || 0)));
  if (tx.fee > 0) { out += line("Biaya", rp(tx.fee)); out += line("TOTAL BAYAR", rp(tx.grand_total)); }
  out += "-".repeat(width) + "\n";
  (tx.checkout_payments || tx.payments || []).forEach((p) => (out += line(p.method, rp(p.amount))));
  out += line("Bayar", rp(tx.paid));
  out += line("Kembali", rp(tx.change));
  out += "-".repeat(width) + "\n";
  if (tx.note) out += "Catatan: " + tx.note + "\n" + "-".repeat(width) + "\n";
  out += center(s.footer || "*** TERIMA KASIH ***");
  out += "\n\n\n";

  // Init + kepekatan maksimal agar tidak pudar:
  // ESC @ (reset) · ESC 7 (heat maks) · ESC E 1 (bold) · ESC G 1 (double-strike)
  const bytes = [0x1b, 0x40, 0x1b, 0x37, 0x07, 0xff, 0x02, 0x1b, 0x45, 0x01, 0x1b, 0x47, 0x01];
  for (const ch of out) {
    const c = ch.charCodeAt(0);
    bytes.push(c < 256 ? c : 0x3f);
  }
  bytes.push(0x0a, 0x0a, 0x1d, 0x56, 0x00);
  return new Uint8Array(bytes);
}

export async function printViaBluetooth(tx, settings, cashier) {
  if (!navigator.bluetooth) {
    throw new Error("Browser tidak mendukung Bluetooth. Gunakan Chrome di Android/desktop.");
  }
  const payload = buildEscpos(tx, settings, cashier);
  const device = await navigator.bluetooth.requestDevice({
    acceptAllDevices: true,
    optionalServices: [
      0x18f0, 0xff00, 0xffe0,
      "000018f0-0000-1000-8000-00805f9b34fb",
      "0000ff00-0000-1000-8000-00805f9b34fb",
      "49535343-fe7d-4ae5-8fa9-9fafd205e455",
    ],
  });
  const server = await device.gatt.connect();
  const services = await server.getPrimaryServices();
  let ch = null;
  for (const svc of services) {
    const chars = await svc.getCharacteristics();
    for (const c of chars) {
      if (c.properties.write || c.properties.writeWithoutResponse) { ch = c; break; }
    }
    if (ch) break;
  }
  if (!ch) throw new Error("Karakteristik tulis printer tidak ditemukan");
  const chunk = 180;
  for (let i = 0; i < payload.length; i += chunk) {
    const slice = payload.slice(i, i + chunk);
    if (ch.properties.writeWithoutResponse) await ch.writeValueWithoutResponse(slice);
    else await ch.writeValue(slice);
    await new Promise((r) => setTimeout(r, 25));
  }
  try { device.gatt.disconnect(); } catch (e) { /* ignore */ }
}
